import React from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons"

import { flattenPages } from "features/Docs/manifest"

interface DocsPagerLinksProps {
  route: string
}

/** Previous / next page cards, derived from the flattened manifest order. */
const DocsPagerLinks: React.FC<DocsPagerLinksProps> = ({ route }) => {
  const flat = flattenPages()
  const index = flat.findIndex((entry) => entry.route === route)
  if (index < 0) return null

  const previous = index > 0 ? flat[index - 1] : undefined
  const next = index < flat.length - 1 ? flat[index + 1] : undefined

  return (
    <nav className="docs-pager" aria-label="Page navigation">
      {previous ? (
        <Link className="docs-pager__link docs-pager__link--prev" to={previous.route}>
          <span className="docs-pager__dir">
            <FontAwesomeIcon icon={faArrowLeft} /> Previous
          </span>
          <span className="docs-pager__title">{previous.page.title}</span>
        </Link>
      ) : (
        <span />
      )}
      {next ? (
        <Link className="docs-pager__link docs-pager__link--next" to={next.route}>
          <span className="docs-pager__dir">
            Next <FontAwesomeIcon icon={faArrowRight} />
          </span>
          <span className="docs-pager__title">{next.page.title}</span>
        </Link>
      ) : (
        <span />
      )}
    </nav>
  )
}

export default DocsPagerLinks
